"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1953,5240],{

/***/ 10700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CarouselItem */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39091);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86173);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91712);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21669);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36797);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11972);
/* harmony import */ var swiper_css_grid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_grid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_1__/* .Scrollbar */ .LW, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rj]);
const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].span.withConfig({
  displayName: "Carousel__Wrapper",
  componentId: "sc-1vzw1za-0"
})(["position:relative;display:", ";.swiper-grid-column{height:100%;}"], props => props.withCustomNavigation ? 'block' : 'inline');
/*
  workaround
  @see https://github.com/nolimits4web/swiper/issues/4413
  @see https://github.com/nolimits4web/swiper/issues/4084
*/

const Item = ({
  children
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: children
  });
};

const CarouselItem = ({
  children
}) => /*#__PURE__*/_jsx(SwiperSlide, {
  children: children
});

const Carousel = ({
  children,
  withScrollbar,
  withNavigation,
  withCustomNavigation,
  withPagination,
  slidesPerView,
  spaceBetween,
  className,
  breakpoints,
  grid
}) => {
  const {
    0: uniqueId,
    1: setUniqueId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setUniqueId(`${Math.random()}`.substring(2, 15));
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Wrapper, {
    className: className || '',
    withCustomNavigation: withCustomNavigation,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
      navigation: withCustomNavigation ? {
        nextEl: `.carousel-custom-next--${uniqueId}`,
        prevEl: `.carousel-custom-prev--${uniqueId}`
      } : withNavigation || false,
      pagination: withPagination ? {
        clickable: true
      } : false,
      scrollbar: withScrollbar ? {
        draggable: true,
        hide: false
      } : false,
      slidesPerView: slidesPerView || 'auto',
      spaceBetween: spaceBetween || 1,
      breakpoints: breakpoints,
      grid: grid,
      loopFillGroupWithBlank: true,
      children: [withCustomNavigation && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-next carousel-custom-next--${uniqueId}`
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: `carousel-custom-prev carousel-custom-prev--${uniqueId}`
        })]
      }), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, child => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
        children: child
      }))]
    })
  });
};

Carousel.Item = Item;
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);

/***/ }),

/***/ 20326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_OfferGalleryContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/uikit/index.tsx + 33 modules
var uikit = __webpack_require__(58598);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/components/common/Carousel.tsx
var Carousel = __webpack_require__(10700);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OfferGallery/Main.tsx







const StyledOverlay = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Main__StyledOverlay",
  componentId: "sc-11gq4gw-0"
})(["position:relative;display:inline-block;width:100%;height:100%;&:after{content:'';position:absolute;left:0;top:0;width:100%;height:100%;display:inline-block;background:linear-gradient(to bottom,rgba(255,255,255,0) 70%,rgba(0,0,0,0.5) 100%);}"]);

const MainImage = ({
  src,
  alt,
  badge
}) => /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
  borderRadius: 10,
  pos: "relative",
  overflow: "hidden",
  bg: "baseWhite",
  w: "full",
  h: "35rem",
  cursor: "pointer",
  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledOverlay, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: src,
      layout: "fill",
      alt: alt,
      objectFit: "contain"
    })
  }), badge && badge.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* GalleryMainBadge */.uH, {
    children: badge
  })]
});

/* harmony default export */ var Main = (MainImage);
;// CONCATENATED MODULE: ./src/components/OfferGallery/index.tsx










const OfferGallery = ({
  images,
  showMore,
  badge,
  maxItems = 3
}) => {
  const {
    0: open,
    1: setOpen
  } = (0,react.useState)(true);
  const {
    0: slide,
    1: setSlide
  } = (0,react.useState)(1);

  const onImageClick = (open, slide) => {
    setOpen(open);
    setSlide(slide);
  };

  const maxItemsSliced = maxItems - 1;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      bgColor: "baseWhite",
      mx: "-1rem",
      mt: "2",
      mb: "5",
      p: "5px",
      borderRadius: "10px",
      display: {
        base: 'block',
        md: 'none'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        slidesPerView: 1,
        withNavigation: true,
        withScrollbar: true,
        spaceBetween: 30,
        className: "offer-gallery-carousel",
        children: images.map((image, idx) => {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel/* default.Item */.Z.Item, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
              w: "100%",
              h: "16rem",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: image.src,
                alt: image.alt,
                loading: idx === 0 ? undefined : 'lazy',
                layout: "fill",
                objectFit: "contain"
              })
            })
          }, `${image.src}${image.alt}`);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
      as: index_esm/* Stack */.Kq,
      maxW: "6xl",
      minHeight: "40rem",
      display: {
        base: 'none',
        md: 'block'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
        templateColumns: "3fr 1fr",
        gap: "xs",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          onClick: () => onImageClick(!open, 1),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
            src: images[0].src,
            alt: images[0].alt,
            badge: badge
          })
        }), images && /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
          children: [images.slice(1).map((image, index) => {
            if (index > maxItemsSliced) return;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* ImageButton */.zA, {
              src: image.src,
              alt: image.alt,
              onClick: () => onImageClick(!open, index + 2),
              marginBottom: index < maxItemsSliced ? 'xs' : '',
              action: index === maxItemsSliced ? showMore : undefined
            }, `${image.src}-${image.alt}`);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(uikit/* LightBox */.ql, {
            status: open,
            images: images,
            slide: slide
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var components_OfferGallery = (OfferGallery);
;// CONCATENATED MODULE: ./src/containers/OfferGalleryContainer.tsx





const OfferGalleryContainer = ({
  images,
  badge
}) => {
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components_OfferGallery, {
    showMore: t('common:gallery.showMore'),
    images: images,
    badge: badge
  });
};

/* harmony default export */ var containers_OfferGalleryContainer = (OfferGalleryContainer);

/***/ }),

/***/ 85240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */

/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend(target = {}, src = {}) {
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}

const ssrDocument = {
  body: {},

  addEventListener() {},

  removeEventListener() {},

  activeElement: {
    blur() {},

    nodeName: ''
  },

  querySelector() {
    return null;
  },

  querySelectorAll() {
    return [];
  },

  getElementById() {
    return null;
  },

  createEvent() {
    return {
      initEvent() {}

    };
  },

  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},

      setAttribute() {},

      getElementsByTagName() {
        return [];
      }

    };
  },

  createElementNS() {
    return {};
  },

  importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}

const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},

    pushState() {},

    go() {},

    back() {}

  },
  CustomEvent: function CustomEvent() {
    return this;
  },

  addEventListener() {},

  removeEventListener() {},

  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }

    };
  },

  Image() {},

  Date() {},

  screen: {},

  setTimeout() {},

  clearTimeout() {},

  matchMedia() {
    return {};
  },

  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },

  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }

};

function getWindow() {
  const win =  true ? window : 0;
  extend(win, ssrWindow);
  return win;
}



/***/ })

}]);